// Guided tours: "seen" flags and the startTour() request channel (module-level, like Toast.tsx), so the help panel
// can start a tour without props or Redux. TourHost subscribes and does the work (navigating first if needed).

// "Seen" lives in localStorage, so it is per browser: a user on a new browser / device sees each tour once more.
// Key: investi_tour_seen:{username}:{tourId} = "1". Storage that throws (private mode, blocked) counts as seen,
// so a tour never keeps popping up; it can still be started from the help panel.
const seenKey = (username: string, tourId: string) => `investi_tour_seen:${username}:${tourId}`;

export const isTourSeen = (username: string, tourId: string) => {
    try {
        return window.localStorage.getItem(seenKey(username, tourId)) === '1';
    } catch {
        return true;
    }
};

export const markTourSeen = (username: string, tourId: string) => {
    try {
        window.localStorage.setItem(seenKey(username, tourId), '1');
    } catch {
        // storage unavailable: nothing to remember, and isTourSeen already treats it as seen
    }
};

let listeners: ((tourId: string) => void)[] = [];

// starts the tour now, or after navigating to its page (TourHost waits for the first step's target)
export const startTour = (tourId: string) => listeners.forEach(l => l(tourId));

export const onStartTour = (listener: (tourId: string) => void) => {
    listeners.push(listener);
    return () => { listeners = listeners.filter(l => l !== listener); };
};
